export default "__VITE_ASSET__DaRsKf3l__"